<app-add-usuario [usuarios]="usuarios"></app-add-usuario>
<mat-card-content class="catalog-list" *ngFor="let usuario of usuarios">
  <form
    [formGroup]="editarForm"
    class="nuevo-catalogo-form"
    *ngIf="user$ | async as user">
    <mat-card class="catalog-card">
      <div
        class="catalog-card-view"
        *ngIf="
          !editandoRegistro ||
          (editandoRegistro && registroSeleccionado !== usuario)
        ">
        <div class="" style="padding: 1rem">
          <p class="catalog-title">
            {{ usuario?.nombre }}
          </p>
          <p>{{ usuario?.mail }}</p>
        </div>
        <mat-card-actions align="end" class="nuevo-catalogo-actions">
          <mat-slide-toggle
            *ngIf="user.rol === 4"
            color="primary"
            hideIcon="true"
            labelPosition="before"
            [checked]="usuario.mostrar"
            (change)="mostrarOcultar($event, usuario)"
            >Mostrar</mat-slide-toggle
          >
          <button
            class="uppercase-button editar"
            mat-button
            (click)="editarRegistro(usuario)">
            Editar
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
    <div *ngIf="admonCatUsuariosStatus$ | async as usuariosStatus">
      <mat-card
        class="catalog-card"
        *ngIf="
          usuariosStatus.mostrarEditar && registroSeleccionado === usuario
        ">
        <div class="" style="padding: 1rem">
          <h3 class="heading-3">Editar usuario</h3>

          <section class="nuevo-catalogo-form">
            <mat-form-field class="nuevo-catalogo-field">
              <mat-label>Nombre</mat-label>
              <input
                [disabled]="true"
                formControlName="nombre"
                name="nombre"
                class="nuevo-catalogo-input"
                type="text"
                maxlength="75"
                matInput
                placeholder="" />
              <mat-hint align="end"
                >{{ editarForm.get("nombre")?.value.length }} / 75</mat-hint
              >
              @if (editarForm.get('nombre')?.invalid &&
              editarForm.get('nombre')?.touched &&
              !editarForm.get('nombre')?.hasError('nombreUsuario')) {
              <mat-error>Campo obligatorio</mat-error>
              } @if (editarForm.get('nombre')?.invalid &&
              editarForm.get('nombre')?.touched &&
              editarForm.get('nombre')?.hasError('nombreUsuario')) {
              <mat-error>Solo se permiten caracteres alfabéticos.</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="nuevo-catalogo-field">
              <mat-label>Correo electrónico</mat-label>
              <input
                formControlName="mail"
                name="mail"
                class="nuevo-catalogo-input"
                type="text"
                maxlength="150"
                [disabled]="true"
                matInput
                placeholder="" />
              @if (editarForm.get('mail')?.invalid &&
              editarForm.get('mail')?.touched&&
              !editarForm.get('mail')?.hasError('invalidEmail')) {
              <mat-error>Campo obligatorio</mat-error>
              } @if (editarForm.get('mail')?.invalid &&
              editarForm.get('mail')?.touched &&
              editarForm.get('mail')?.hasError('invalidEmail')) {
              <mat-error>{{
                "El correo electrónico proporcionado es incorrecto, por favor ingréselo en el siguiente formato: usuario/a@dominio Ej: ejemplo@gnp.com.mx"
              }}</mat-error>
              }
            </mat-form-field>
            <p class="subtitle-catalogos !mb-0">Seleccione un rol</p>
            <mat-radio-group
              aria-labelledby="example-radio-group-label"
              class="radio-group mt-3 mb-3"
              formControlName="rol"
              name="rol">
              @for (rol of catRoles; track rol) {
              <mat-radio-button
                [color]="rol.rol == 4 ? 'primary' : 'warn'"
                class="rol-radio-button"
                [value]="rol.rol"
                >{{ rol.label }}</mat-radio-button
              >
              }
            </mat-radio-group>

            <section
              *ngIf="
                editarForm.get('rol') &&
                editarForm.get('rol')?.value == 1 &&
                user.rol === 4
              ">
              <p class="subtitle-catalogos !mb-3 !m-t3 !ml-0 !mr-0">
                Envío a AB
              </p>
              <mat-checkbox
                color="warn"
                class="presentar-usuario-check !mb-3"
                type="checkbox"
                formControlName="formaEnvio"
                name="formaEnvio"
                >Presentar usuario en catálogo</mat-checkbox
              >
              <!-- <div class="container-catalogos-flex !mb-3 !m-t3 !ml-0 !mr-0">
                <input
                  type="checkbox"
                  formControlName="formaEnvio"
                  name="formaEnvio"
                  class="nuevo-catalogo-check" />
                <span class="text-cataloogos"
                  >Presentar usuario en catálogo</span
                >
              </div> -->
            </section>
            <section *ngIf="user.rol === 4">
              <p class="subtitle-catalogos">Permisos</p>
              <div class="nuevo-catalogo-permisos">
                <mat-form-field class="mat-form-field-combo">
                  <mat-label>Tema</mat-label>
                  <mat-select formControlName="tema" name="tema">
                    @for (permiso of catTemas; track permiso) {
                    <mat-option [value]="permiso">{{
                      permiso.descripcion
                    }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="mat-form-field-combo">
                  <mat-label>Acción</mat-label>
                  <mat-select formControlName="accion" name="accion">
                    @for (accion of catAcciones; track accion) {
                    <mat-option [value]="accion">{{ accion.label }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <section class="container-catalogos-flex">
                  <mat-checkbox
                    color="warn"
                    class="!mb-3"
                    type="checkbox"
                    formControlName="notificacion"
                    value="notificacion"
                    >Notificaciones</mat-checkbox
                  >
                  <!-- <input
                    formControlName="notificacion"
                    value="notificacion"
                    class="nuevo-catalogo-check"
                    type="checkbox" />
                  <span class="text-cataloogos">Notificaciones</span> -->
                </section>
                <button
                  (click)="nuevoPermiso()"
                  mat-mini-fab
                  aria-label="Agregar nuevo tipo"
                  color="primary">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </section>
          </section>
          <section
            class="nuevo-catalogo-form-chips"
            style="padding: 1rem"
            *ngIf="user.rol === 4">
            <mat-chip-grid #chipGrid aria-label="Fruit selection">
              @for (permiso of permisosSeleccionados; track permiso) {
              <mat-chip-row (removed)="removePermiso(permiso)">
                {{ permiso.descChip }}
                <button
                  matChipRemove
                  [attr.aria-label]="'remove ' + permiso.descChip">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
              }
            </mat-chip-grid>
            <hr />
          </section>

          <mat-card-actions class="nuevo-catalogo-actions">
            @if (user.rol === 4) {
            <button
              class="uppercase-button"
              mat-flat-button
              color="warn"
              (click)="eliminarUsuario(usuario)">
              Borrar
            </button>
            }@else {
            <p></p>
            }

            <div class="nuevo-catalogo-actions-cg">
              <button
                class="uppercase-button"
                mat-stroked-button
                (click)="cancelarEdicion()">
                Cancelar
              </button>
              <button
                class="uppercase-button"
                mat-flat-button
                color="primary"
                [disabled]="validateFilds()"
                (click)="guardarCambios(usuario)">
                Guardar
              </button>
            </div>
          </mat-card-actions>
        </div>
      </mat-card>
    </div>
  </form>
</mat-card-content>
<br />
